var MantleUI = MantleUI || {};
var MantleGrid = MantleGrid || {};
var MantleWindow = MantleWindow || {};

(function ($) {
  if (Drupal.behaviors.filterableGrid) {
    return;
  }

  // Copy of String.prototype.startsWith
  // Remove polyfill because 3rd party libs were clashing.
  var startsWith = function (str, search, rawPos) {
    var pos = rawPos > 0 ? rawPos | 0 : 0;

    return str.substring(pos, pos + search.length) === search;
  };
  /*
   * Util for hash a string into an number.
   */
  var hashCode = function (value) {
    var hash = 0,
      i,
      chr;

    for (i = 0; i < value.length; i++) {
      chr = value.charCodeAt(i);
      hash = (hash << 5) - hash + chr;
      hash |= 0; // Convert to 32bit integer
    }

    return hash;
  };
  /*
   * Logic for filling out a grid with no empty spaces.
   *
   * Tile refers to 1x1 space. So a 2x2 block is worth 4 tiles.
   */
  var FullGridLogic = function (itemCount) {
    // Default settings
    this.itemCount = itemCount;
    this._bigCount = 0;
    this._columnsPerRow = 7;
    this._isMobile = Unison.fetch.now().name === 'small';
  };

  // setters
  FullGridLogic.prototype.setBigCount = function (bigCount) {
    this._bigCount = bigCount;
  };

  FullGridLogic.prototype.setColumnsPerRow = function (columnsPerRow) {
    this._columnsPerRow = columnsPerRow;
  };

  FullGridLogic.prototype.setIsMobile = function (isMobile) {
    this._isMobile = isMobile;
  };

  // getters
  FullGridLogic.prototype.bigCount = function () {
    if (this.isMobile()) {
      return 0;
    }

    return this._bigCount;
  };

  FullGridLogic.prototype.columnsPerRow = function () {
    if (this.isMobile()) {
      return 3;
    }

    return this._columnsPerRow;
  };

  FullGridLogic.prototype.isMobile = function () {
    return this._isMobile;
  };

  // tile count. Convert for 2x2 blocks.
  FullGridLogic.prototype.tileCount = function () {
    return this.bigCount() * 4 + (this.itemCount - this.bigCount());
  };

  // # of rows we're trying to fill. Minimum of 2.
  FullGridLogic.prototype.rowTarget = function () {
    var rowTarget = Math.ceil(this.tileCount() / this.columnsPerRow());

    if (rowTarget < 2) {
      rowTarget = 2;
    }

    return rowTarget;
  };

  // # of tiles needed to complete coverage.
  FullGridLogic.prototype.targetTilecount = function () {
    return this.rowTarget() * this.columnsPerRow();
  };

  // # of tiles needed to completely fill in grid.
  FullGridLogic.prototype.backfillCount = function () {
    return this.targetTilecount() - this.tileCount();
  };

  /*
   * FilterableGrid coordinates the following components:
   * 1. MantleGrid
   * 2. FilterableGridMenu
   * 3. StateFlag Handlers (grid_tile_v1).
   *
   * The menu handlers filter state, which gets passed to MantleGrid for
   * filtering and StateFlag for state based changes such as image changes.
   */
  var FilterableGrid = function ($formatter) {
    this.$formatter = $formatter;
    this.$stateFlagHandlers = $('[data-handle-state-flags="1"]', this.$grid);
    this.$grid = $('.js-filterable-grid__grid', $formatter);

    this.dataset = $formatter.data('dataset');
    this.stateFlags = {};

    this.editorialConfigs = $formatter.data('editorial-config');
    this.defaultLandingFilter = $formatter.data('default-landing-filter');

    this.setupDomEvents();

    this.rangeTickDirector = new MantleUI.MantleRangeTickDirector([]);
    this.registerWidgets(this.rangeTickDirector);
    this.rangeTickDirector.initialize();

    this.pageSet = false;
    this.setPageFromAnchor();
  };
  // Cache this value ASAP.
  var windowHash = window.location.hash;

  FilterableGrid.prototype.setPageFromAnchor = function () {
    if (!windowHash) {
      return;
    }

    if (this.pageSet) {
      return;
    }

    this.pageSet = true;

    // TRy to grab hash
    var hash = null;
    var $matchedLink = null;

    hash = window.location.hash.substring(1);

    if (!startsWith(hash, '/lip-finder')) {
      return;
    }

    // disable autoscroll in chrome
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    var hashKey = hash.substring(12);
    var $formatter = this.$formatter;
    var $grid = this.$grid;
    var $links = $('[data-filter-tag]', $formatter);

    // Try to match anchor
    $links.each(function (i, obj) {
      var $link = $(obj);
      var tagKey = $link.data('filter-tag');

      if (hashKey === tagKey) {
        $matchedLink = $link;

        return false;
      }
    });

    if ($matchedLink) {
      var mixer = $grid.data('mixitup-mixer');

      mixer.configure({
        animation: {
          duration: 0
        }
      });
      $matchedLink.trigger('click');
      // reset
      mixer.configure({
        animation: {
          duration: 500
        }
      });
    }

    window.setTimeout(function () {
      $('body,html').animate(
        {
          scrollTop: $formatter.offset().top - 60
        },
        800 // speed
      );
    }, 700);
  };

  /*
   * Dom Events.
   */
  FilterableGrid.prototype.setupDomEvents = function () {
    var self = this;

    this.$grid.on('mantle-grid:init-dataItem', function (e, item, $gridItem, metadata) {
      self.alterGridDataItem(item, $gridItem, metadata);
    });

    this.$formatter.on('filterable-grid-menu:filterStateChange', function (e, filterState) {
      self.handleFilterStateChange(e, filterState);
    });

    MantleWindow.onResizeWidth(
      function () {
        self.onResizeWidth();
      },
      null,
      200
    );
  };

  FilterableGrid.prototype.onResizeWidth = function () {
    this.isMobile = Unison.fetch.now().name === 'small';
  };

  /*
   * Handle filterStateChange emitted by the menu.
   */
  FilterableGrid.prototype.handleFilterStateChange = function (e, filterState) {
    var stateFlags = filterState.stateFlags;
    var filterQuery = filterState.filterQuery;

    // We have UI difference based on whether menu is completely empty of
    // state.
    if (stateFlags._empty) {
      this.$formatter.addClass('filter-grid--unfiltered');
    } else {
      this.$formatter.removeClass('filter-grid--unfiltered');
    }

    /*
     * Notify the stateFlagHandlers that we have a new state
     */
    this.$stateFlagHandlers.each(function (i, obj) {
      var $handler = $(obj);

      $handler.triggerHandler('set-state-flags', [stateFlags]);
    });
    this.stateFlags = stateFlags;

    // Always show the promo tiles. We hide them in remixedDatasetAlter
    var newFilterQuery = {
      __type: 'OR',
      filterQuery: filterQuery,
      promo: true
    };

    // Tell the grid to filter.
    this.rangeTickDirector.setFilterQuery(newFilterQuery);
  };

  /*
   * Add filter tags
   */
  FilterableGrid.prototype.alterGridDataItem = function (item, $gridItem) {
    // All items are filterable
    item.filterable = true;

    var dataset = this.dataset;
    var datasetItem = dataset[item.id];

    if (!datasetItem) {
      return;
    }
    var filter_tags = datasetItem.filter_tags;

    if (filter_tags) {
      _.each(filter_tags, function (tag) {
        item.filters[tag] = true;
      });
    }

    // Mark item as promo
    if (item.filters.promo) {
      item.promo = true;
      $gridItem.addClass('promo');
    }

    if (datasetItem.promo_index) {
      $gridItem.attr('data-promo-index', datasetItem.promo_index);
    }

    var $tile = $('> div', $gridItem);
    var classList = $tile.attr('class').split(/\s+/);

    $.each(classList, function (index, cls) {
      if (startsWith(cls, 'promo-tag--')) {
        item.promo_key = cls.substring(11);
      }
    });

    var skuBaseId = $tile.data('sku-base-id');

    if (skuBaseId) {
      item.skuBaseId = parseInt(skuBaseId);
    }
  };

  /*
   * Quick util for checking whether mixitup.mixer is attached to a
   * FitlerableGrid.
   */
  FilterableGrid.prototype.isFilterableGridMixer = function (mixitup, mixer) {
    var h = mixitup.h;
    var container = mixer.dom.container;

    return h.hasClass(container, 'js-filterable-grid__grid');
  };

  /*
   * Uses the mixitup registerAction api to hook into the internals. This is
   * done for proper animations and munging datasets prior to render.
   */
  FilterableGrid.prototype.addMixitupActions = function (mixitup) {
    var filterableGrid = this;

    /*
     * We hook into beforeDiffDatasets so we can update the cached Target.data
     * with updated data from remixedDatasetAlter.
     */
    mixitup.Mixer.registerAction('beforeDiffDatasets', 'fitlerableGrid', function (operation) {
      var i,
        id,
        target,
        data = null;
      // this points to the mixer.
      var self = this;

      // Make sure to only apply to Fitlerable Grid
      if (!filterableGrid.isFilterableGridMixer(mixitup, self)) {
        return;
      }

      for (i = 0; i < operation.newDataset.length; i++) {
        data = operation.newDataset[i];
        id = data[self.config.data.uidKey];
        if (typeof id === 'undefined' || id.toString().length < 1) {
          continue;
        }
        if ((target = self.cache[id]) instanceof mixitup.Target) {
          // update target data
          target.data = data;
        }
      }
    });

    /*
     * This patches in before we take the Inter size calculations. Any size
     * changes we want to do should be done here for smooth animations.
     */
    mixitup.Mixer.registerAction('afterSetInter', 'fitlerableGrid', function (operation) {
      var i, target, data;
      // this points to the mixer.
      var self = this;

      // Make sure to only apply to Fitlerable Grid
      if (!filterableGrid.isFilterableGridMixer(mixitup, self)) {
        return;
      }

      for (i = 0; i < operation.show.length; i++) {
        target = operation.show[i];
        data = target.data;
        // Ease of us, call a FilterableGrid method.
        filterableGrid.alterTargetDom(target.dom.el, data);
      }
    });
  };

  /*
   * Register the MantleRangeTickDirector widgets and apply mixitup actions
   */
  FilterableGrid.prototype.registerWidgets = function (rangeTickDirector) {
    var self = this;
    var gridWidget = new MantleUI.MantleGridRTWidget({
      widgetKey: 'grid',
      element: self.$grid,
      itemSelector: '.js-filterable-grid__grid-item',
      gridOptions: {
        remixedDatasetAlter: function (remixedDataset, mixer, filter, sort) {
          return self.remixedDatasetAlter(remixedDataset, mixer);
        },
        initialDatasetAlter: function (remixedDataset, mixer, initialFilter, initialSort) {
          return self.defaultLandingDatasetAlter(remixedDataset, mixer);
        }
      }
    });

    // eslint-disable-next-line
    this.addMixitupActions(mixitup);

    rangeTickDirector.addWidget(gridWidget);
  };

  /*
   * The combination of the addMixitupActions and remixedDatasetAlter gives us
   * the following api.
   *
   * remixDatasetAlter allows us to modify the dataset after a fitler has been
   * applied. This allows us to resize blocks or add back in editorial blocks.
   */
  // eslint-disable-next-line complexity
  FilterableGrid.prototype.remixedDatasetAlter = function (remixedDataset, mixer) {
    var editorialDataset = this.remixedDatasetAlter_Editorial(this, remixedDataset);

    if (editorialDataset) {
      return editorialDataset;
    }

    return this.remixedDatasetAlter_Auto(remixedDataset);
  };

  FilterableGrid.prototype.getEditorialConfigs = function () {
    return this.editorialConfigs;
  };

  // eslint-disable-next-line complexity
  FilterableGrid.prototype.getEditorialConfig = function (stateKey) {
    var isMobile = Unison.fetch.now().name === 'small';
    var configs = this.getEditorialConfigs();

    if (!configs) {
      return;
    }

    // If we pass in explicit stateKey. Then check only for that.
    if (stateKey) {
      return configs[stateKey];
    }

    var config = null;

    for (var flag in this.stateFlags) {
      if (flag in configs) {
        config = configs[flag];
        break;
      }
    }

    if (!config) {
      return null;
    }

    // We're set for desktop
    if (!isMobile) {
      return config;
    }

    // If config is also set to work on mobile. Gucci.
    if (config.isMobile) {
      return config;
    }

    // config can have its own mobileConfig.
    if (config.mobileConfig) {
      return config.mobileConfig;
    }

    return null;
  };

  /*
   * Run through the dataset and set a key per item.
   */
  FilterableGrid.prototype.getKeyedDataset = function () {
    if (!this.keyedDataset) {
      var $grid = this.$grid;
      var gridDataset = $grid.data('grid-dataset');
      // Prep the datasets
      var keyedDataset = {};

      for (var i = 0; i < gridDataset.length; i++) {
        var item = gridDataset[i];

        if (item.promo) {
          keyedDataset[item.promo_key] = item;
        } else {
          keyedDataset['SKU' + item.skuBaseId] = item;
        }
      }
      this.keyedDataset = keyedDataset;
    }

    return this.keyedDataset;
  };

  /*
   * This is a special case that handles the default landing state of the grid.
   * This is both called by when generating the initialDataset and when
   * resetting the dataset from a filtered state.
   */
  FilterableGrid.prototype.defaultLandingDatasetAlter = function (remixedDataset, mixer) {
    var defaultLandingFilter = this.defaultLandingFilter;

    if (!defaultLandingFilter) {
      return;
    }

    var defaultFilter = {};

    defaultFilter[defaultLandingFilter] = true;
    var defaultDataset = MantleGrid.Filter.filterDataset(remixedDataset, defaultFilter);

    return defaultDataset;
  };

  /*
   * Allow editorial overrides with a json config.
   */
  // eslint-disable-next-line complexity
  FilterableGrid.prototype.remixedDatasetAlter_Editorial = function (remixedDataset, mixer) {
    var editorialDataset = [];
    var keyedDataset = this.getKeyedDataset();
    var config = this.getEditorialConfig();

    if (!config) {
      return;
    }

    if (config.columns) {
      this.$formatter.attr('data-columns', config.columns);
    } else {
      this.$formatter.removeAttr('data-columns');
    }

    // Prep the datasets
    for (var i = 0; i < config.items.length; i++) {
      var configItem = config.items[i];
      var configKey = configItem.key;
      var matchedItem = keyedDataset[configKey];

      if (!matchedItem) {
        continue;
      }

      // editiroail has no fillin
      matchedItem.fillin = false;
      matchedItem.big = false;
      matchedItem.column = null;
      matchedItem.row = null;
      matchedItem.defaultSkinTone = configItem.skin_tone;
      if (configItem.big) {
        matchedItem.big = true;
      }
      if (configItem.column) {
        matchedItem.column = configItem.column;
      }
      if (configItem.row) {
        matchedItem.row = configItem.row;
      }
      editorialDataset.push(matchedItem);
    }

    return editorialDataset;
  };

  /*
   * A dataset alter that tries to fill in the grid so that there are no empty
   * spots.
   */
  // eslint-disable-next-line complexity
  FilterableGrid.prototype.remixedDatasetAlter_Auto = function (remixedDataset, mixer) {
    var i, item;
    var newDataset = [];
    var promoItems = [];

    // Reset all the dataitems.
    for (i = 0; i < remixedDataset.length; i++) {
      item = remixedDataset[i];
      // reset
      item.big = false;
      item.fillin = false;
      item.column = null;
      item.row = null;
      item.defaultSkinTone = 'default';
    }

    // If we have no filters set. Just unset the big blocks and return.
    if (!this.stateFlags.filtered) {
      this.$formatter.removeAttr('data-columns');

      return this.defaultLandingDatasetAlter(remixedDataset, mixer);
    }

    // Prep the datasets
    for (i = 0; i < remixedDataset.length; i++) {
      item = remixedDataset[i];
      if (item.promo) {
        promoItems.push(item);
      } else {
        newDataset.push(item);
      }
    }

    var itemCount = newDataset.length;
    var logic = new FullGridLogic(itemCount);

    logic.setBigCount(1); // default to one big block

    if (itemCount <= 4) {
      logic.setBigCount(2);
      logic.setColumnsPerRow(6);
      this.$formatter.attr('data-columns', 6);
    } else if (logic.rowTarget() <= 3) {
      // We don't want a bunch of editorial tiles if we can help it.
      if (logic.backfillCount() > 3) {
        logic.setBigCount(2);
      }
      this.$formatter.removeAttr('data-columns');
    } else {
      //
    }

    // Place big tiles.
    var big_index = 0;

    for (i = 0; i < newDataset.length; i++) {
      var isBig = false;

      item = newDataset[i];
      item.big = false; // reset
      if (!this.stateFlags.filtered) {
        continue;
      }

      // Always set first block to big.
      if (i === 0) {
        isBig = true;
      }

      // For results with 3 or less rows. Mark the 4th as big.
      if (logic.rowTarget() <= 3 && big_index < logic.bigCount() && i === 4) {
        isBig = true;
      }

      // If we still need a big and we're at the end.
      if (big_index < logic.bigCount() && i === newDataset.length - 1) {
        isBig = true;
      }

      if (isBig) {
        big_index++;
        item.big = true;
        item.big_index = big_index;
      }
    }

    // Backfill single space tiles with editorial promos.
    var backfillCount = logic.backfillCount();
    // Stable random number based on stateFlags.
    var randomSeed = hashCode(Object.keys(this.stateFlags).join('|'));

    for (i = 0; i < backfillCount; i++) {
      if (promoItems.length === 0) {
        break;
      }
      item = promoItems.splice(
        Math.floor((randomSeed / promoItems.length) % promoItems.length),
        1
      )[0];
      if (!item) {
        break;
      }
      item.fillin = true;
      item.fillin_index = i + 1;
      newDataset.splice((i + 1) * 3, 0, item);
    }

    return newDataset;
  };

  /*
   * After remixDatasetAlter, this function is used to apply any metadata in
   * the dataset item and apply it to the griditem dom.
   */
  // eslint-disable-next-line complexity
  FilterableGrid.prototype.alterTargetDom = function (el, data) {
    var $el = $(el);

    // handle big 2x2
    if (data.big) {
      $el.addClass('big');
      $el.attr('data-big-index', data.big_index);
    } else {
      $el.removeClass('big');
      $el.removeAttr('data-big-index');
    }

    // backfilling promo items.
    if (data.fillin) {
      $el.addClass('fillin');
      $el.attr('data-fillin-index', data.fillin_index);
    } else {
      $el.removeClass('fillin');
      $el.removeAttr('data-fillin-index');
    }

    // set Default image color
    if (data.defaultSkinTone) {
      var $tile = $('> .js-grid-tile', el);
      var defaultSkinTone = data.defaultSkinTone;

      $tile.triggerHandler('grid-tile:set-default-image-to-tag', [defaultSkinTone, true]);
    }

    // Allow speciying grid placement
    if (data.column) {
      $el.attr('data-grid-column', data.column);
    } else {
      $el.removeAttr('data-grid-column');
    }
    if (data.row) {
      $el.attr('data-grid-row', data.row);
    } else {
      $el.removeAttr('data-grid-row');
    }
  };

  Drupal.behaviors.filterableGrid = {
    attach: function (context) {
      var $formatters = $('.js-filterable-grid', context);

      $formatters.each(function (i, obj) {
        var $formatter = $(obj);
        var options = {};
        var filterableGrid = new FilterableGrid($formatter, options);

        $formatter.data('filterable-grid-manager', filterableGrid);
      });
    }
  };
})(jQuery);
